import { UserPreferences } from './preferences';

export enum Permissions {
    userManagement = 'userManagement',
    userManagement_deleteUser = 'userManagement_deleteUser',
    parcelSearch = 'parcelSearch',
    parcelSearch_extendedSearch = 'parcelSearch_extendedSearch',
    parcelSearch_deliveryPictures = 'parcelSearch_deliveryPictures',
    parcelSearch_deliveryPicturesIncludeAll = 'parcelSearch_deliveryPicturesIncludeAll',
    shippingPortal_returns = 'shippingPortal_returns',
    shippingPortal_transfers = 'shippingPortal_transfers',
    shippingPortal_outbound = 'shippingPortal_outbound',
    shippingPortal_unfilteredDestinations = 'shippingPortal_unfilteredDestinations',
    reports_transferReport = 'reports_transferReport', // These are for powerBI reports
    reports_returnsReport = 'reports_returnsReport', // These are for powerBI reports
    reports_otdReport = 'reports_otdReport',
    reports_plsReportAllSources = 'reports_plsReportAllSources',
    reports_volumeReportAllSources = 'reports_volumeReportAllSources',
    reports_eltMetricsReport = 'reports_eltMetricsReport',
    reports_billing = 'reports_billing',
    reports_tenderExceptionReport = 'reports_tenderExceptionReport',
    reports_distressedParcels = 'reports_distressedParcels',
    reports_fmtpActivityReport = 'reports_fmtpActivityReport',
    reports_assetTracking = 'reports_assetTracking',
    reports_scanDetail = 'reports_scanDetail',
    reports_osdmReport = 'reports_osdmReport',
    reports_osd_manifest = 'reports_osd_manifest',
    reports_returns = 'reports_returns', // These are for sigma reports
    reports_transfers = 'reports_transfers', // These are for sigma reports
    shipmentTracking = 'shipmentTracking',
    deliveryManagementTool = 'deliveryManagementTool',
    exportData = 'exportData',
}

export enum PermissionContext {
    GLOBAL,
    CUSTOMER,
    DEALER,
}

export const PermissionContextMapping: Record<Permissions, PermissionContext> =
    {
        [Permissions.userManagement]: PermissionContext.DEALER,
        [Permissions.userManagement_deleteUser]: PermissionContext.GLOBAL,
        [Permissions.parcelSearch]: PermissionContext.CUSTOMER,
        [Permissions.parcelSearch_extendedSearch]: PermissionContext.GLOBAL,
        [Permissions.parcelSearch_deliveryPictures]: PermissionContext.GLOBAL,
        [Permissions.parcelSearch_deliveryPicturesIncludeAll]:
            PermissionContext.GLOBAL,
        [Permissions.shippingPortal_returns]: PermissionContext.DEALER,
        [Permissions.shippingPortal_transfers]: PermissionContext.DEALER,
        [Permissions.shippingPortal_outbound]: PermissionContext.DEALER,
        [Permissions.shippingPortal_unfilteredDestinations]:
            PermissionContext.GLOBAL,
        [Permissions.reports_transferReport]: PermissionContext.GLOBAL,
        [Permissions.reports_returnsReport]: PermissionContext.GLOBAL,
        [Permissions.reports_otdReport]: PermissionContext.GLOBAL,
        [Permissions.reports_plsReportAllSources]: PermissionContext.GLOBAL,
        [Permissions.reports_volumeReportAllSources]: PermissionContext.GLOBAL,
        [Permissions.reports_eltMetricsReport]: PermissionContext.GLOBAL,
        [Permissions.reports_billing]: PermissionContext.GLOBAL,
        [Permissions.reports_tenderExceptionReport]: PermissionContext.GLOBAL,
        [Permissions.reports_distressedParcels]: PermissionContext.GLOBAL,
        [Permissions.reports_fmtpActivityReport]: PermissionContext.GLOBAL,
        [Permissions.reports_assetTracking]: PermissionContext.GLOBAL,
        [Permissions.reports_scanDetail]: PermissionContext.GLOBAL,
        [Permissions.reports_osdmReport]: PermissionContext.GLOBAL,
        [Permissions.reports_osd_manifest]: PermissionContext.GLOBAL,
        [Permissions.shipmentTracking]: PermissionContext.DEALER,
        [Permissions.deliveryManagementTool]: PermissionContext.GLOBAL,
        [Permissions.exportData]: PermissionContext.GLOBAL,
        [Permissions.reports_returns]: PermissionContext.CUSTOMER,
        [Permissions.reports_transfers]: PermissionContext.CUSTOMER,
    };

export type UserPermission = Partial<
    Record<Permissions, EntityAccess[] | boolean>
>;

export enum EntityType {
    CUSTOMER = 'customer',
    DEALER = 'dealer',
    ACCESS_ALL_CUSTOMERS = 'accessAllCustomers',
}

export type EntityAccess =
    | {
          type: EntityType.CUSTOMER | EntityType.DEALER;
          id: string;
      }
    | {
          type: EntityType.ACCESS_ALL_CUSTOMERS;
      };

export type FmtpUser = {
    userId: string;
    permissions: UserPermission;
    firstName: string;
    lastName: string;
    dateFrom: Date;
    dateUntil: Date | null;
    createdOn: Date;
    createdBy: string;
    modifiedOn: Date | null;
    modifiedBy: string | null;
    preferences?: Partial<UserPreferences>;
};

export type FmtpTransientStorageUser = {
    userId: string;
    permissions: UserPermission;
};

export type FmtpUserResponse = {
    username: string;
    id: string;
    email: string;
    enabled: boolean;
    firstName: string;
    lastName: string;
    permissions: UserPermission;
    createdBy: string;
    isFederated: boolean;
};
